export const getTransactions = (state) => state.transactions.items;
export const getCategories = (state) => state.transactions.categories;
export const getCategoriesStats = (state) => state.transactions.stats;
export const getCategoriesList = (state) => state.transactions.categoriesList;
export const getBalance = (state) => state.transactions.balance;
